// widths.js
export const drawerWidth = 140;
export const fullDrawerWidth = 210;
